import script from "./SlotModalRolesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlotModalRolesList.vue?vue&type=script&setup=true&lang=ts"

import "./SlotModalRolesList.vue?vue&type=style&index=0&id=d6a29fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6a29fa4"]])

export default __exports__